import { WhitelabelConfig } from '@whitelabel/types';

const WikibuyWhitelabelConfig: WhitelabelConfig = {
    displayName: 'Wikibuy',
    termsOfUseUrl: 'https://capitaloneshopping.rockettravelhotels.com/terms',
    privacyPolicyUrl: 'https://capitaloneshopping.rockettravelhotels.com/privacy',
};

export default WikibuyWhitelabelConfig;
